<template>
  <footer class="relative lg:fixed lg:bottom-0 lg:left-0 lg:right-0 w-full max-w-full mt-8 lg:mt-0 border-t border-slate-800/60 bg-gradient-to-b from-slate-900/60 to-slate-900/95 backdrop-blur-sm lg:z-40 overflow-hidden">
    <div class="max-w-6xl xl:max-w-7xl 2xl:max-w-[90rem] mx-auto px-3 sm:px-4 py-2 sm:py-3">
      <!-- Responsive layout: stacked on mobile, row on desktop -->
      <div class="flex flex-col lg:flex-row items-center justify-center gap-2 sm:gap-3 lg:gap-6">
        <!-- Socials -->
        <div class="flex items-center gap-2 sm:gap-3 shrink-0">
          <a href="https://x.com/StarvaraGame" target="_blank" rel="noopener"
             class="social-link"
             title="X">
            <img :src="iconX" alt="X" class="h-5 w-5 sm:h-6 sm:w-6 aspect-square object-contain" />
          </a>
          <a href="https://t.me/+KoQFHyXjtcMwOTc0" target="_blank" rel="noopener"
             class="social-link"
             title="Telegram">
            <img :src="iconTelegram" alt="Telegram" class="h-5 w-5 sm:h-6 sm:w-6 aspect-square object-contain" />
          </a>
          <a href="https://discord.com/invite/n9sxKKwZKs" target="_blank" rel="noopener"
             class="social-link"
             title="Discord">
            <img :src="iconDiscord" alt="Discord" class="h-5 w-5 sm:h-6 sm:w-6 aspect-square object-contain" />
          </a>
          <a href="https://www.instagram.com/starvaragame/" target="_blank" rel="noopener"
             class="social-link"
             title="Instagram">
            <img :src="iconInstagram" alt="Instagram" class="h-5 w-5 sm:h-6 sm:w-6 aspect-square object-contain" />
          </a>
          <a href="https://www.youtube.com/@StarvaraOfficial" target="_blank" rel="noopener"
             class="social-link"
             title="YouTube">
            <img :src="iconYoutube" alt="YouTube" class="h-5 w-5 sm:h-6 sm:w-6 aspect-square object-contain" />
          </a>
        </div>

        <!-- Contracts -->
        <div
          class="flex flex-wrap items-center justify-center gap-2 sm:gap-3 lg:gap-4 text-xs sm:text-sm text-[#B8DAFF]"
          style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
        >
          <!-- VRX -->
          <div class="inline-flex items-center gap-1 sm:gap-1.5">
            <span class="font-medium whitespace-nowrap">VRX</span>
            <span class="font-mono text-[#B8DAFF]/50 text-[10px] sm:text-xs" :title="props.vrx">
              {{ shortAddr(props.vrx) }}
            </span>
            <button
              @click="copyToClipboard(props.vrx)"
              class="p-0.5 rounded hover:bg-slate-800/60 focus:outline-none focus:ring-2 focus:ring-sky-400/40"
              title="Copy VRX address"
            >
              <img :src="iconCopy" alt="Copy VRX" class="h-3.5 w-3.5 sm:h-4 sm:w-4 aspect-square object-contain shrink-0" />
            </button>
          </div>

          <!-- USDT -->
          <div class="inline-flex items-center gap-1 sm:gap-1.5">
            <span class="font-medium whitespace-nowrap">USDT</span>
            <span class="font-mono text-[#B8DAFF]/50 text-[10px] sm:text-xs" :title="props.usdt">
              {{ shortAddr(props.usdt) }}
            </span>
            <button
              @click="copyToClipboard(props.usdt)"
              class="p-0.5 rounded hover:bg-slate-800/60 focus:outline-none focus:ring-2 focus:ring-sky-400/40"
              title="Copy USDT address"
            >
              <img :src="iconCopy" alt="Copy USDT" class="h-3.5 w-3.5 sm:h-4 sm:w-4 aspect-square object-contain shrink-0" />
            </button>
          </div>

          <!-- VRXKEY -->
          <div class="inline-flex items-center gap-1 sm:gap-1.5">
            <span class="font-medium whitespace-nowrap">VRXKEY</span>
            <span class="font-mono text-[#B8DAFF]/50 text-[10px] sm:text-xs" :title="props.keyAddr">
              {{ shortAddr(props.keyAddr) }}
            </span>
            <button
              @click="copyToClipboard(props.keyAddr)"
              class="p-0.5 rounded hover:bg-slate-800/60 focus:outline-none focus:ring-2 focus:ring-sky-400/40"
              title="Copy VRXKEY address"
            >
              <img :src="iconCopy" alt="Copy VRXKEY" class="h-3.5 w-3.5 sm:h-4 sm:w-4 aspect-square object-contain shrink-0" />
            </button>
          </div>

          <!-- CORE -->
          <div class="inline-flex items-center gap-1 sm:gap-1.5">
            <span class="font-medium whitespace-nowrap">CORE</span>
            <span class="font-mono text-[#B8DAFF]/50 text-[10px] sm:text-xs" :title="props.core">
              {{ shortAddr(props.core) }}
            </span>
            <button
              @click="copyToClipboard(props.core)"
              class="p-0.5 rounded hover:bg-slate-800/60 focus:outline-none focus:ring-2 focus:ring-sky-400/40"
              title="Copy Core contract address"
            >
              <img :src="iconCopy" alt="Copy Core" class="h-3.5 w-3.5 sm:h-4 sm:w-4 aspect-square object-contain shrink-0" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tiny toast -->
    <transition name="fade">
      <div
        v-if="toast.show"
        class="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none
               px-3 py-2 rounded-lg border border-slate-700/60 shadow-lg
               bg-gradient-to-b from-[#101832] to-[#080C19] text-[#B8DAFF] text-sm"
      >
        {{ toast.text }}
      </div>
    </transition>
  </footer>
</template>

<script setup>
  import { defineProps, ref } from 'vue'

  import iconX from '../assets/LinkX.svg'
  import iconInstagram from '../assets/LinkInstagram.svg'
  import iconYoutube from '../assets/LinkYoutube.svg'
  import iconDiscord from '../assets/LinkDiscord.svg'
  import iconTelegram from '../assets/LinkTelegram.svg'
  import iconCopy from '../assets/copy_icon.png'

  const props = defineProps({
    vrx: { type: String, default: '' },
    usdt: { type: String, default: '' },
    keyAddr: { type: String, default: '' },
    core: { type: String, default: '' }
  })

  // Toast state
  const toast = ref({ show: false, text: 'Copied to clipboard' })
  let toastTimer = null
  function showToast(msg = 'Copied to clipboard') {
    toast.value.text = msg
    toast.value.show = true
    if (toastTimer) clearTimeout(toastTimer)
    toastTimer = setTimeout(() => { toast.value.show = false }, 1600)
  }

  function fallbackCopy(s) {
    try {
      const el = document.createElement('textarea')
      el.value = s
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      showToast()
    } catch { /* noop */ }
  }

  function copyToClipboard(text) {
    if (!text) return
    const s = String(text)
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(s).then(
        () => showToast(),
        () => fallbackCopy(s)
      )
    } else {
      fallbackCopy(s)
    }
  }

  /** Shorten to format: 0x3fA2f...03B27813 */
  function shortAddr(addr) {
    if (!addr) return ''
    const s = String(addr)
    const has0x = s.startsWith('0x') || s.startsWith('0X')
    const body = has0x ? s.slice(2) : s
    if (body.length <= 13) return s
    const head = body.slice(0, 5)
    const tail = body.slice(-8)
    return (has0x ? '0x' : '') + head + '...' + tail
  }
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity .18s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* Social links */

.social-link {
  @apply rounded-lg p-2 relative;
  @apply transition-all duration-200 ease-out;
  @apply focus:outline-none;
  border: 1px solid transparent;
}

.social-link:hover {
  border: 1px solid rgba(56, 189, 248, 0.4);
  background: rgba(56, 189, 248, 0.05);
  box-shadow: 0 0 12px rgba(56, 189, 248, 0.15);
}

.social-link img {
  @apply transition-opacity duration-200;
  opacity: 0.5;
}

.social-link:hover img {
  opacity: 1;
}
</style>
